import { createSlice } from "@reduxjs/toolkit";

import {
  getUnitTypeThunk,
  createUnitTypeThunk,
  updateUnitTypeThunk,
  deleteUnitTypeThunk,
} from "state/action/unit_type";

// Initial state
const initialState = {
  // Get UnitType inisial state
  getUnitType: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Create UnitType inisial state
  createUnitType: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Update UnitType inisial state
  updateUnitType: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Delete UnitType inisial state
  deleteUnitType: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // UnitType object value
  unit_type_object_value: "",
};

export const unitTypeSlice = createSlice({
  name: "unit_type",
  initialState,
  reducers: {
    setGetUnitTypeObjectValue: (state, action) => {
      return {
        ...state,
        unit_type_object_value: action.payload,
      };
    },
    // note: clear state
    setClearGetUnitTypeObjectValue: (state, _) => {
      return {
        ...state,
        unit_type_object_value: "",
      };
    },
    setClearGetUnitType: (state, _) => {
      return {
        ...state,
        getUnitType: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearCreateUnitType: (state, _) => {
      return {
        ...state,
        createUnitType: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearUpdateUnitType: (state, _) => {
      return {
        ...state,
        updateUnitType: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearDeleteUnitType: (state, _) => {
      return {
        ...state,
        deleteUnitType: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearAllUnitTypeState: (state, _) => {
      return {
        ...state,
        // Get UnitType inisial state
        getUnitType: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Create UnitType inisial state
        createUnitType: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Update UnitType inisial state
        updateUnitType: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Delete UnitType inisial state
        deleteUnitType: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // UnitType object value
        UnitType_object_value: "",
      };
    },
  },
  extraReducers(builder) {
    builder
      // Get UnitType reducer
      .addCase(getUnitTypeThunk.pending, (state, _) => {
        return {
          ...state,
          getUnitType: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getUnitTypeThunk.fulfilled, (state, action) => {
        return {
          ...state,
          getUnitType: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getUnitTypeThunk.rejected, (state, action) => {
        return {
          ...state,
          getUnitType: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // Create UnitType reducer
      .addCase(createUnitTypeThunk.pending, (state, _) => {
        return {
          ...state,
          register: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(createUnitTypeThunk.fulfilled, (state, action) => {
        return {
          ...state,
          register: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(createUnitTypeThunk.rejected, (state, action) => {
        return {
          ...state,
          register: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // update UnitType reducer
      .addCase(updateUnitTypeThunk.pending, (state, _) => {
        return {
          ...state,
          updateUnitType: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updateUnitTypeThunk.fulfilled, (state, action) => {
        return {
          ...state,
          updateUnitType: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updateUnitTypeThunk.rejected, (state, action) => {
        return {
          ...state,
          updateUnitType: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      });
  },
});

export const unitTypeAction = {
  ...unitTypeSlice.actions,
  getUnitTypeThunk,
  createUnitTypeThunk,
  updateUnitTypeThunk,
  deleteUnitTypeThunk,
};

export function selectUnitTypeObjectValue(state) {
  return state?.unit_type?.unit_type_object_value;
}

export function selectUnitType(state) {
  return state?.unit_type;
}

export default unitTypeSlice.reducer;
